import {
  Component,
  computed,
  ElementRef,
  HostListener,
  inject,
  input,
  model,
  output,
  signal,
  ViewChild,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

export interface TenantSelectItem {
  id: string | number;
  name: string;
}
@Component({
  selector: 'app-admin-tenant-select',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './admin-tenant-select.component.html',
  styleUrl: './admin-tenant-select.component.css',
})
export class AdminTenantSelectComponent {
  private readonly translate = inject(TranslateService);
  openDropdown = signal(false);
  selectedTenant = model('');
  list = input<TenantSelectItem[]>([]);
  private searchTerm = signal('');

  filteredList = computed(() => {
    const all = this.list();
    const term = this.searchTerm();
    if (!term) {
      return all;
    }
    return all.filter((item: TenantSelectItem) =>
      item.name.toLowerCase().startsWith(term)
    );
  });

  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  onSelect = output<TenantSelectItem>();
  placeholder = computed(() => {
    const selected = this.selectedTenant();
    return selected ? selected : this.translate.instant('admin.loadingTenants');
  });

  @ViewChild('dropdownList', { static: false }) dropdownList!: ElementRef;
  @ViewChild('searchInput', { static: false })
  searchInput!: ElementRef<HTMLInputElement>;

  toggleDropdown() {
    this.openDropdown.set(!this.openDropdown());
  }
  onKeyUp(event: KeyboardEvent) {
    const target = event.target as HTMLInputElement;
    this.searchTerm.set(target.value.toLowerCase());
    // The dropdown should stay open as long as there is text or results
    this.openDropdown.set(
      target.value.length > 0 || this.filteredList().length > 0
    );
  }

  @HostListener('document:click', ['$event'])
  handleClickOutside(event: MouseEvent) {
    if (!this.openDropdown()) {
      return;
    }
    const target = event.target as HTMLElement;
    const dropdownMenuElement = this.dropdownList.nativeElement;

    if (!dropdownMenuElement.contains(target) && this.dropdownList) {
      this.openDropdown.set(false);
      this.clearTenantSearchInput();
    }
  }

  onSelectItem(item: TenantSelectItem) {
    this.selectedTenant.set(item.name);
    this.clearTenantSearchInput();
    this.onSelect.emit(item);
    this.toggleDropdown();
  }

  clearTenantSearchInput() {
    if (this.searchInput) {
      this.searchInput.nativeElement.value = '';
    }
    this.searchTerm.set('');
  }
}
